/** @format */

import {OrderBasicDetails} from 'frontier-components';
import React from 'react';

export const OrderDescriptionColumn = props => {
    const {order} = props;

    return (
        <div className="single-active-order-10cn__column--description">
            <OrderBasicDetails order={order} />
        </div>
    );
};
